/** Byte → insan-okur boyut ("512 B" / "3.4 KB" / "1.2 MB"). Dosya eki listelerinde ortak. */
export function formatBytes(bytes: number): string {
  if (!bytes || bytes < 1024) return `${bytes || 0} B`
  const kb = bytes / 1024
  if (kb < 1024) return `${kb.toFixed(kb < 10 ? 1 : 0)} KB`
  return `${(kb / 1024).toFixed(1)} MB`
}

/** Dosya adından uzantı ("Rapor.pdf" → "pdf"); nokta yoksa "" (yüklenmemiş yerel dosyada tür sütunu için). */
export function fileExtension(name: string): string {
  const i = name.lastIndexOf('.')
  return i >= 0 && i < name.length - 1 ? name.slice(i + 1) : ''
}
